let TestPrimaryPlayer = {
  type: "ChangePrimaryPlayer",
  charID: 123456789,
  charName: "Anna Pavlova"
};

export default TestPrimaryPlayer;
